import i18n from '@/i18n'
export default {
    columns: (vm) => {
      return [{
        type: 'selection',
        width: 60,
        align: 'center'
      },{
        title: i18n.t('device.columns.586949-0'),
        key: 'DeviceCode',
        resizable: true,
        minWidth: 140,
        sortable: true,
        align: 'center'
      },
      {
        title: i18n.t('device.columns.586949-1'),
        key: 'UserDeviceName',
        resizable: true,
        sortable: true,
        minWidth: 160,
        align: 'center'
      },
      {
        title: i18n.t('device.columns.586949-2'),
        key: 'DeviceId',
        resizable: true,
        sortable: true,
        minWidth: 100,
        align: 'center',
        render: (h, params) => {
            let text = '-'
            if (params.row.DeviceId) {
                switch (params.row.DeviceId) {
                    case '6ee95d23-a802-4bd8-b823-19c0944ac5ab':
                        text = i18n.t('device.columns.586949-3')
                        break;
                    case 'c1ce34cd-a623-45db-8025-3104efa35be5':
                        text = i18n.t('device.columns.586949-4')
                        break;
                    case '4782d02c-0075-4105-9729-aa1b65bb250a':
                        text = i18n.t('device.columns.586949-5')
                        break;
                    case '88f5c429-49b6-4a9f-a908-b2ee9c8cb857':
                        text = i18n.t('device.columns.586949-6')
                        break;
                    case '7febbea4-0326-496d-9b71-5b058729cb42':
                        text = i18n.t('device.columns.586949-7')
                        break;
                    default:
                        text = i18n.t('device.columns.586949-8')
                        break;
                }
            }
            return h('span', {}, text);
        }
      },
      {
        title: i18n.t('device.columns.586949-2'),
        key: 'IsOnline',
        resizable: true,
        sortable: true,
        minWidth: 100,
        align: 'center',
        render: (h, params) => {
          return h('span', {}, params.row.IsOnline ? i18n.t('device.columns.586949-9') : i18n.t('device.columns.586949-10'));
        }
      },
      {
        title: i18n.t('device.columns.586949-11'),
        key: 'Address',
        resizable: true,
        sortable: true,
        minWidth: 240,
        align: 'center'
      }]
    }
  }
  


// WEBPACK FOOTER //
// ./src/components/useGas/views/device/mods/device/columns.js